<script>
  import { onMount } from "svelte";
  import maplibregl from "maplibre-gl";
  import Header from "../../components/Header.svelte";
  import { videosStore } from "../store";
  import { navigate } from "svelte-routing";

  let map = null;
  let marker = null;
  let latitude = 0;
  let longitude = 0;
  let radius = 1; // Default radius value

  const storedVideosKey = "storedVideos";

  onMount(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          latitude = position.coords.latitude;
          longitude = position.coords.longitude;
          initializeMap();
        },
        (error) => {
          console.error("Error getting user location:", error);
          initializeMap(); // Initialize map with default location if geolocation fails
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
      initializeMap(); // Initialize map with default location if geolocation is not supported
    }
  });

  function initializeMap() {
    // console.log("Initializing map...");

    map = new maplibregl.Map({
      container: "map",
      style:
        "https://api.maptiler.com/maps/23dcaeeb-8b75-450b-990c-778aaf087f1e/style.json?key=vIljITtCdwhZcKweYUVg",
      center: [longitude, latitude],
      zoom: 12,
    });

    marker = new maplibregl.Marker()
    .setLngLat([longitude, latitude])
      .addTo(map);

    map.on("click", (e) => {
      const { lng, lat } = e.lngLat;
      // console.log(`Clicked at longitude: ${lng}, latitude: ${lat}`);
      marker.setLngLat([lng, lat]);
      latitude = lat;
      longitude = lng;
    });
  }

  async function searchVideosByLocationDateTime() {
    try {
      let url = `https://api.trulens.ae/api/videos/2search?latitude=${latitude}&longitude=${longitude}&radius=${radius}`;

      if (radioButtonSelected === "exact") {
        url += `&dateTime=${exactDateTime}&_=${Date.now()}`;
      } else if (radioButtonSelected === "fromto") {
        url += `&fromDate=${fromDateTime}&toDate=${toDateTime}&_=${Date.now()}`;
      }

      const response = await fetch(url);

      if (response.ok) {
        const videos = await response.json();
        localStorage.removeItem(storedVideosKey); // Remove previous stored videos
        localStorage.setItem(storedVideosKey, JSON.stringify(videos)); // Store new videos in localStorage
        videosStore.set(videos); // Update the videos store
        navigateToResults();
      } else {
        videosStore.set([]);
        localStorage.removeItem(storedVideosKey); // Clear stored videos if search fails
        navigateToResults();
      }

      //     if (response.ok) {
      //       const videos = await response.json();
      //       // console.log("Videos found:", videos);
      //       videosStore.set(videos);
      //       navigateToResults();
      //     } else {
      //       // console.error(
      //       // "Failed to search videos by location:",
      //       // response.statusText
      //       // );
      //       videosStore.set([]);
      //       navigateToResults();
      //     }
    } catch (error) {
      console.error("Error searching videos by location and date-time:", error);
      videosStore.set([]);
      localStorage.removeItem(storedVideosKey); // Clear stored videos on error
      navigateToResults();
    }
  }

  function navigateToResults() {
    window.location.href = "#/results";
  }

  let exactDateTime = new Date();
  let fromDateTime = new Date();
  let toDateTime = new Date();
  let radioButtonSelected = "exact";
  let showFromTo = false;

  function handleRadioButtonChange(event) {
    radioButtonSelected = event.target.value;
    showFromTo = radioButtonSelected !== "exact";
    // console.log("Selected radio button value:", radioButtonSelected);
  }

  function handleExactDateTimeChange(event) {
    exactDateTime = event.target.value;
    // console.log("Exact datetime selected:", exactDateTime);
  }

  function handleFromDateTimeChange(event) {
    fromDateTime = event.target.value;
    // console.log("From datetime selected:", fromDateTime);
  }

  function handleToDateTimeChange(event) {
    toDateTime = event.target.value;
    // console.log("To datetime selected:", toDateTime);
  }

  function handleRadiusChange(event) {
    radius = event.target.value;
    // console.log("Radius selected:", radius);
  }
</script>

<link
  href="https://unpkg.com/maplibre-gl/dist/maplibre-gl.css"
  rel="stylesheet"
/>

<Header />
<div class="title">
  <span class="title-span">Location and Date Time</span>
</div>

<br />

<div class="map-container" id="map" style="height: 400px;"></div>

<div class="container">
  <div class="radio-buttons">
    <label class="radio-label">
      <input
        type="radio"
        bind:group={radioButtonSelected}
        value="exact"
        on:change={handleRadioButtonChange}
        class="radio-input"
      />
      Exact
    </label>

    <label class="radio-label">
      <input
        type="radio"
        bind:group={radioButtonSelected}
        value="fromto"
        on:change={handleRadioButtonChange}
        class="radio-input"
      />
      From/To
    </label>
  </div>

  {#if radioButtonSelected === "exact"}
    <div class="date-time-picker">
      <label for="exactDateTimePicker">Exact Datetime:</label>
      <input
        type="datetime-local"
        id="exactDateTimePicker"
        bind:value={exactDateTime}
        on:change={handleExactDateTimeChange}
        class="datetime-input"
      />
    </div>
  {/if}

  {#if showFromTo}
    <div class="date-time-picker">
      <label for="fromDateTimePicker">From Datetime:</label>
      <input
        type="datetime-local"
        id="fromDateTimePicker"
        bind:value={fromDateTime}
        on:change={handleFromDateTimeChange}
        class="datetime-input"
      />

      <label for="toDateTimePicker">To Datetime:</label>
      <input
        type="datetime-local"
        id="toDateTimePicker"
        bind:value={toDateTime}
        on:change={handleToDateTimeChange}
        class="datetime-input"
      />
    </div>
  {/if}

  <div class="radius">
    <label for="radiusInput">Radius (in km): </label>
    <input
      type="number"
      id="radiusInput"
      bind:value={radius}
      min="1"
      step="1"
      on:change={handleRadiusChange}
    />
  </div>

  <button on:click={searchVideosByLocationDateTime}>Search</button>
</div>

<style>
  .container {
    max-width: 400px;
    margin: 0 auto;
    padding: 20px;
  }

  .title {
    position: relative;
    display: flex;
    justify-content: center;
    padding: 10px;
    box-shadow: 0 4px 8px rgba(135, 135, 135, 0.1);
    /* background: linear-gradient(to bottom, #FF3C82 45%, #1e92ff 55%); */
    /* background: linear-gradient(130deg, #cdb4db, #ffffff);
    box-shadow:
      inset -20px 0 50px #cdb4db,
      inset 20px 0 50px #cdb4db; */
  }

  .title-span {
    margin-top: 5px;
    /* border: 2px solid #000000; */
    border-radius: 25%;
    /* margin: 0 15px; */
    padding: 5px;
    font-size: 1.2rem;
    color: #000000;
    /* text-decoration: underline; */
    /* cursor: pointer; */
    font-size: 1.4rem;
    font-weight: bold;
  }

  .map-container {
    width: 90%;
    max-width: 800px;
    margin: 0 auto;
    border: 1px solid #ccc;
    border-radius: 8px;
    overflow: hidden;
  }

  .radius {
    display: flex;
    align-items: center;
    margin-bottom: 20px; /* Adjust as needed */
  }

  .radius label {
    margin-right: 10px; /* Adjust as needed */
    font-size: 1rem;
    color: #333;
  }

  .radius input {
    padding: 5px;
    font-size: 1rem;
    height: 50px; /* Adjust the height as needed */
    width: 70%; /* Adjust the width as needed */
    outline: none;
    transition: border-color 0.3s ease;
    border-radius: 5px;
    border: 1px solid #ffafcc;
    box-sizing: border-box;
  }

  /* .radius input:focus {
    border-color: #ff3c82;
  } */

  .radio-buttons {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
  }

  .radio-label {
    margin-right: 30px;
    color: #333;
  }

  .radio-input {
    margin-right: 5px;
    transform: scale(1.2);
    accent-color: #ff3c82;
  }

  .date-time-picker {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
  }

  label {
    margin-bottom: 5px;
    font-size: 1rem;
    color: #333;
  }

  .datetime-input {
    width: 100%;
    padding: 5px;
    font-size: 1rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    height: 50px;
    outline: none;
    transition: border-color 0.3s ease;
  }

  .datetime-input:focus {
    border-color: #ff3c82;
  }

  button {
    display: block;
    width: 100%;
    padding: 10px 20px;
    font-size: 1rem;
    font-weight: bold;
    color: #fff;
    background-color: #ff3c82;
    border: none;
    height: 50px;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  button:hover {
    background-color: #b683d4;
  }

  @media (max-width: 768px) {
    .title {
      padding: 10px 20px;
    }

    .title-span {
      font-size: 1.2rem;
    }

    .map-container {
      width: 95%;
      height: 300px;
    }

    button {
      width: 100%;
      font-size: 0.9rem;
      padding: 8px 16px;
    }

    input[type="number"] {
      width: calc(100% - 35%);
      margin-right: 0;
    }
  }

  @media screen and (min-width: 768px) {
    .title {
      margin-top: 40px;
    }
  }

  @media screen and (min-width: 850px) {    
    .title {
      margin-top: 5px;
    }
  }

  @media screen and (min-width: 850px) and (min-height: 1280px) {    
    .title {
      margin-top: 55px;
    }
  }

  @media screen and (min-width: 1024px) and (max-width: 1024px) and (max-height: 600px) {
    .title {
      margin-top: 5px;
    }
  }

  @media screen and (min-width: 1024px) and (min-height: 1300px) {
    .title {
      margin-top: 60px;
    }
  }

  @media screen and (min-width: 1440px) {
    .title {
      margin-top: 20px;
    }
  }
</style>
